export const EDITOR_ROOT_PATH =
  '/dashboard/inquiry-templates/:inquiryTemplateId/:inquiryTemplateVersionId';
